import { Helmet } from "react-helmet"
import { PasswordWarning } from "../../PasswordWarning"
const NeedsToBeResetTeacherPortalScreen = ({schoolName, schoolAbb, setFirstPass, resetPass2, passwordSubmit, passWarning}) => {
    return(
        <>
            <Helmet>
                <title>{`${schoolName}`}</title>
            </Helmet>
            <div className="login-page pass-reset-page">
            <div className="login-header">
                {schoolAbb} Teacher Portal
            </div>
            <div className="login-box">
                <div className="login-box-title">Password Reset</div>
                <input className="password-input login-input" type="password" placeholder="New password" onChange={e => setFirstPass(e.target.value)} ></input>
                <input className="password-input login-input" type="password" placeholder="Confirm password" onChange={e => resetPass2(e.target.value)} ></input>
                <PasswordWarning passWarning={passWarning} />
                <div className="login-btn reset-pass-btn" onClick={() => passwordSubmit()}>Reset Password</div>
                <div className="password-reset-explaination">Since this is your first time logging in, please enter a personalized password you can remember. Thank you!</div>
            </div>
        </div>
        </>
        )
}
export default NeedsToBeResetTeacherPortalScreen